import React, { useEffect, useState } from "react";
import {
  Typography,
  DatePicker,
  Select,
  Table,
  TreeSelect,
  Space,
  Badge,
} from "antd";
import moment from "moment";
import {
  openNotificationWithIcon,
  errorHandle,
  generateArrWeekAndDays,
  getDateRange,
} from "../../Function";
import systemInfoApi from "../../../api/getServerInfo";
import {
  GetDataOvertimeApi,
  changeStatusOTApi,
} from "../../../api/getOvertime";
import Button from "antd-button-color"; //npm install antd-button-color  || https://www.npmjs.com/package/antd-button-color
import "antd-button-color/dist/css/style.css";
import {
  CheckOutlined,
  CloseOutlined,
  MinusSquareOutlined,
  PlusSquareOutlined,
  SendOutlined,
} from "@ant-design/icons";
import { GetDataDuAnApi } from "../../../api/getInfoData";
import { useSelector } from "react-redux";
import { ListBoPhanApi } from "../../../api/getListTeam";
import { data_ot } from "./data";
import ModalDetailItem from "./Overtime/Modals/ModalDetailItem";
import ModalAddOvertime from "./Overtime/Modals/ModalAddOvertime";
import ModalDeleteItem from "./Overtime/Modals/ModalDeleteItem";

const { Link } = Typography;

const getHeader = (data, date) => {
  return (
    <span>
      {new Date(data).getDay() === 0
        ? "CN"
        : "Thứ " + (new Date(data).getDay() + 1)}
      <br />
      {moment(data).format("DD/MM/YYYY")}
    </span>
  );
};

const RenderSingleInnerItem = ({
  record,
  text,
  currentDate,
  setIsShowDetailItem,
  setCurrentItem,
  setCurrentDateSelected,
}) => {
  const onShowDetailItem = () => {
    setCurrentDateSelected(currentDate);
    setCurrentItem(record);
    setIsShowDetailItem(true);
  };
  const timeRanges = String(text).includes("&&")
    ? String(text).split("&&")
    : [text];
  return (
    <div onClick={onShowDetailItem} style={{ width: "100%" }}>
      <div>{timeRanges[0]}</div>
      <div>{timeRanges.length === 2 && timeRanges[1]}</div>
    </div>
  );
};

const getStyleColorOT = (item) => {
  let result;
  if (item.type === "Error") {
    result = "#FFCAAF";
  } else {
    switch (item.trangthaiDuyet__sortDuyet) {
      case 4:
        result = "red";
        break;
      case 3:
        result = "#75ef42";
        break;
      case 5:
        result = "#31ecd0";
        break;
      case 6:
        result = "#ec238a";
        break;
      case 2:
        result = "#4ca4f1";
        break;
      default:
        result = "#ffffff";
        break;
    }
  }

  return result || "";
};

const RenderItemRow = (
  text,
  record,
  updateData,
  currentDate,
  setIsShowDetailItem,
  setCurrentItem,
  setCurrentDateSelected
) => {
  return (
    <div>
      {text ? (
        <RenderSingleInnerItem
          record={record}
          text={text}
          currentDate={currentDate}
          setIsShowDetailItem={setIsShowDetailItem}
          setCurrentItem={setCurrentItem}
          setCurrentDateSelected={setCurrentDateSelected}
        />
      ) : (
        "-"
      )}
    </div>
  );
};

export const Overtime = () => {
  const defaultPageSize = 10;
  const [pager, setPager] = useState({ pageSize: defaultPageSize });
  const [data, setData] = useState([]);
  const [statusAll, setStatusAll] = useState(null);
  const [lsDate, setLsDate] = useState(getDateRange(moment(new Date())));
  const [lsTeam, setLsTeam] = useState([]);
  const [lsTeamRoleCreateOT, setLsTeamRoleCreateOT] = useState([]);
  const [lsIdOT, setLsIdOT] = useState([]);
  const [isShowAdd, setIsShowAdd] = useState(false);
  const [currentTeam, setCurrentTeam] = useState([]);
  const [lsMemberId, setLsMemberId] = useState([]);
  const [currentSelectedDate, setCurrentSelectedDate] = useState(
    moment(new Date())
  );
  const [loading, setLoading] = useState(false);
  const [isCreate, setIsCreate] = useState(false);
  const [isValid, setIsValid] = useState(true);
  const [search, setSearch] = useState("");
  const [treeData, setTreeData] = useState([]);
  const [columns, setColumns] = useState([]);
  const [lsDuAn, setLsDuAn] = useState([]);
  const [isShowDetailItem, setIsShowDetailItem] = useState(false);
  const [currentItem, setCurrentItem] = useState({});
  const [currentDateSelected, setCurrentDateSelected] = useState(null);
  const [isShowDelete, setIsShowDelete] = useState(false);
  const userInfo = useSelector((state) => state.getUserInfo.userInfo);
  const systemGroup = useSelector((state) => state.systemInfo.systemOTGroup);

  const [lsBoPhan, setLsBoPhan] = useState([]);
  const [currentBoPhan, setCurrentBoPhan] = useState([]);
  const [treeDataBoPhan, setTreeDataBoPhan] = useState([]);
  const [lsAllTeam, setLsAllTeam] = useState([]);
  const [lsAllWeek, setLsAllWeek] = useState([]);
  const [currentWeek, setCurrentWeek] = useState("");

  const mapDataLichOT = (data) => {
    let results = [];
    let lsMemberId = [];
    let lsIdOTTemp = [];
    let isValid = true;
    for (let i of data) {
      if (i.data.length === 0) {
        continue;
      }
      lsMemberId.push(i.id);
      let obj = {};
      obj.nhanvien = i.msnv + "-" + i.username;
      obj.id = i.id;
      obj.total_minot = i.tongPhut;
      obj.total_hourot = i.tongGio;
      obj.status = i.status;
      for (let k of i.data) {
        if (k.type === "Error") {
          isValid = false;
        }
        lsIdOTTemp.push(k.id);
        obj["col" + moment(k.ngay, "YYYY-MM-DD").format("DDMM")] = k;
        obj["time_regist_" + moment(k.ngay, "YYYY-MM-DD").format("DDMM")] =
          (k.gio_vao_1 !== null
            ? moment(k.gio_vao_1, "HH:mm:ss").format("HH:mm")
            : "") +
          (k.gio_vao_1 !== null && k.gio_ra_1 !== null ? " - " : "") +
          (k.gio_ra_1 !== null
            ? moment(k.gio_ra_1, "HH:mm:ss").format("HH:mm")
            : "") +
          (k.gio_vao_1 !== null &&
          k.gio_ra_1 !== null &&
          k.gioVaoDK !== null &&
          k.gioRaDK !== null
            ? "&&"
            : "") +
          (k.gioVaoDK !== null
            ? moment(k.gioVaoDK, "HH:mm:ss").format("HH:mm")
            : "") +
          (k.gioVaoDK !== null && k.gioRaDK !== null ? " - " : "") +
          (k.gioRaDK !== null
            ? moment(k.gioRaDK, "HH:mm:ss").format("HH:mm")
            : "");

        obj["time_actual_" + moment(k.ngay, "YYYY-MM-DD").format("DDMM")] =
          //   (k.gio_vao_tt_ot_1 != ""
          //     ? moment(k?.gio_vao_tt_ot_1, "HH:mm:ss").format("HH:mm")
          //     : "") +
          //   " - " +
          //   (k.gio_ra_tt_ot_1 != ""
          //     ? moment(k?.gio_ra_tt_ot_1, "HH:mm:ss").format("HH:mm")
          //     : "") +
          //   " " +
          (k.gioVaoTT != ""
            ? moment(k.gioVaoTT, "HH:mm:ss").format("HH:mm")
            : "") +
          " - " +
          (k.gioRaTT != ""
            ? moment(k.gioRaTT, "HH:mm:ss").format("HH:mm")
            : "");
        obj["time_system_" + moment(k.ngay, "YYYY-MM-DD").format("DDMM")] =
          (k.gioVaoHT != ""
            ? moment(k.gioVaoHT, "HH:mm:ss").format("HH:mm")
            : "") +
          " - " +
          (k.gioRaHT != ""
            ? moment(k.gioRaHT, "HH:mm:ss").format("HH:mm")
            : "");
        obj["mins_" + moment(k.ngay, "YYYY-MM-DD").format("DDMM")] = k.soPhut;
      }
      results.push(obj);
    }
    setIsValid(isValid);
    setLsIdOT(lsIdOTTemp);

    return [results, lsMemberId];
  };

  const GetLsButton = ({
    permissions,
    systemGroup,
    status,
    lsDate,
    teamPermissions,
  }) => {
    const maxGroup = new Set(systemGroup.map((item) => item.group)).size;
    const BtnDk = () => (
      <Button
        ghost
        type="success"
        className={"m-2"}
        onClick={() => setIsShowAdd(true)}
        icon={<PlusSquareOutlined />}
      >
        Đăng ký tăng ca
      </Button>
    );
    const BtnXoaDk = () => (
      <Button
        ghost
        type="danger"
        className={"m-2"}
        onClick={() => setIsShowDelete(true)}
        icon={<MinusSquareOutlined />}
      >
        Xóa đăng ký
      </Button>
    );
    const BtnGuiPd = () => (
      <Button
        ghost
        type="success"
        className={"m-2"}
        onClick={() =>
          submitApproval("send_approval", ["overtime_xx"], "Gửi phê duyệt")
        }
        icon={<SendOutlined />}
      >
        Gửi phê duyệt
      </Button>
    );
    const BtnGuiPdAndPd = () => (
      <Button
        ghost
        type="success"
        className={"m-2"}
        onClick={() =>
          submitApproval(
            "accept_approval",
            ["overtime_xx", "overtime_pd"],
            "Phê duyệt"
          )
        }
        icon={<CheckOutlined />}
      >
        Phê duyệt
      </Button>
    );
    const BtnPd = () => (
      <Button
        ghost
        type="success"
        className={"m-2"}
        onClick={() =>
          submitApproval("accept_approval", ["overtime_pd"], "Phê duyệt")
        }
        icon={<CheckOutlined />}
      >
        Phê duyệt
      </Button>
    );
    const BtnKhongPd = () => (
      <Button
        ghost
        type="danger"
        className={"m-2"}
        onClick={() =>
          submitApproval("refuse_approval", ["overtime_reject"], "Không duyệt")
        }
        icon={<CloseOutlined />}
      >
        Không duyệt
      </Button>
    );

    // 250823 Update Phê duyệt/Gưi phê duyệt theo view Team
    const arrTeam = teamPermissions
      .filter((e) => currentTeam.includes(e.team) == true)
      .map((item, index) => item.phanquyen__ten_pq);
    const uniqueArrTeam = [...new Set(arrTeam)];

    let results = [
      uniqueArrTeam.includes("overtime_create") && <BtnDk />,
      uniqueArrTeam.includes("overtime_create") &&
        [0, 1, 4, 6].includes(status) && <BtnXoaDk />,
    ];
    if (
      lsDate
        .filter(
          (item) => moment(currentSelectedDate).month() == moment(item).month()
        )
        .at(-1) >= new Date()
    ) {
      return results;
    }

    switch (maxGroup) {
      case 4:
        switch (status) {
          case 1: // Xem xét
          case 4: //NPD không phê duyệt
          case 6: //HR không phê duyệt
            if (
              uniqueArrTeam.includes("overtime_xx") &&
              uniqueArrTeam.includes("overtime_pd")
            ) {
              results.push(<BtnGuiPdAndPd />);
              // console.log(1);
            } else {
              if (uniqueArrTeam.includes("overtime_xx")) {
                results.push(<BtnGuiPd />);
              }
            }
            break;
          case 2: //Chờ NPD duyệt
            if (uniqueArrTeam.includes("overtime_pd")) {
              results.push(<BtnPd />);
            }
            if (uniqueArrTeam.includes("overtime_reject")) {
              results.push(<BtnKhongPd />);
            }
        }
    }

    return results.map((item, index) => <span key={index}>{item}</span>);
  };

  const mapColumnLichOT = (data1) => {
    // lấy danh sách ngày OT của user để tạo columns
    let columns_date = [];
    let ls_date = [];
    data1.map(({ data }) => {
      data.map((item) => {
        // !ls_date.includes(moment(item.ngay,"YYYY-MM-DD")._i) && ls_date.push(moment(item.ngay,"YYYY-MM-DD")._i)
        ls_date.push(moment(item.ngay, "YYYY-MM-DD"));
      });
    });
    // ls_date = [...new Set(ls_date)];
    const comparisonValues = ls_date.map((v) => v.valueOf());
    ls_date = ls_date.filter(
      (v, i) => comparisonValues.indexOf(v.valueOf()) == i
    );
    ls_date.sort((a, b) => a.diff(b));
    for (let i of ls_date) {
      let columns_detail = {};
      let currentDate = i.format("DDMM");
      columns_detail["title"] = getHeader(i, lsDate);
      columns_detail["dataIndex"] = "col" + currentDate;
      columns_detail["key"] = "col" + currentDate;
      columns_detail["filterKey"] = "col" + currentDate;
      columns_detail["type"] = "text";
      columns_detail["className"] = "hoverBlur";
      columns_detail["align"] = "center";
      columns_detail["canSearch"] = true;
      columns_detail["color"] = "red";
      columns_detail["children"] = [
        {
          title: "Giờ đăng ký",
          dataIndex: "time_regist_" + i.format("DDMM"),
          key: "time_regist_" + i.format("DDMM"),
          align: "center",
          className: "hoverBlur",
          width: 100,
          render: (text, record) => {
            return {
              props: {
                style: {
                  borderRadius: 0,
                  background: record["col" + currentDate]
                    ? getStyleColorOT(record["col" + currentDate])
                    : "",
                  borderBottom:
                    record["col" + currentDate] &&
                    record["col" + currentDate].isEditHT
                      ? "3px solid red"
                      : "",
                },
              },
              children: (
                <div style={{ cursor: "pointer" }}>
                  {RenderItemRow(
                    text,
                    record,
                    updateData,
                    currentDate,
                    setIsShowDetailItem,
                    setCurrentItem,
                    setCurrentDateSelected
                  )}
                </div>
              ),
            };
          },
        },

        {
          title: "Giờ thực tế",
          dataIndex: "time_actual_" + i.format("DDMM"),
          key: "time_actual_" + i.format("DDMM"),
          align: "center",
          className: "hoverBlur",
          width: 100,
          render: (text, record) => {
            return {
              props: {
                style: {
                  borderRadius: 0,
                  background: record["col" + currentDate]
                    ? getStyleColorOT(record["col" + currentDate])
                    : "",
                  borderBottom:
                    record["col" + currentDate] &&
                    record["col" + currentDate].isEditHT
                      ? "3px solid red"
                      : "",
                },
              },
              children: (
                <div style={{ cursor: "pointer" }}>
                  {RenderItemRow(
                    text,
                    record,
                    updateData,
                    currentDate,
                    setIsShowDetailItem,
                    setCurrentItem,
                    setCurrentDateSelected
                  )}
                </div>
              ),
            };
          },
        },
        {
          title: "Số phút",
          dataIndex: "mins_" + i.format("DDMM"),
          key: "mins_" + i.format("DDMM"),
          align: "center",
          className: "hoverBlur",
          width: 100,
          render: (text, record) => {
            return {
              props: {
                style: {
                  borderRadius: 0,
                  background: record["col" + currentDate]
                    ? getStyleColorOT(record["col" + currentDate])
                    : "",
                  borderBottom:
                    record["col" + currentDate] &&
                    record["col" + currentDate].isEditHT
                      ? "3px solid red"
                      : "",
                },
              },
              children: (
                <div style={{ cursor: "pointer" }}>
                  {RenderItemRow(
                    text,
                    record,
                    updateData,
                    currentDate,
                    setIsShowDetailItem,
                    setCurrentItem,
                    setCurrentDateSelected
                  )}
                </div>
              ),
            };
          },
        },
      ];
      columns_date.push(columns_detail);
    }
    const columns_first = [
      {
        title: "Nhân viên",
        dataIndex: "nhanvien",
        key: "nhanvien",
        filterKey: "nhanvien",
        className: "highlight",
        type: "text",
        align: "center",
        width: 100,
        canSearch: true,
        fixed: "left",
      },
    ];

    const columns_last = [
      {
        title: "Tổng phút OT",
        dataIndex: "total_minot",
        key: "total_minot",
        filterKey: "total_minot",
        className: "highlight",
        align: "center",
        type: "text",
        canSearch: true,
        width: 100,
        fixed: "right",
      },
      {
        title: "Tổng giờ OT",
        dataIndex: "total_hourot",
        key: "total_hourot",
        filterKey: "total_hourot",
        className: "highlight",
        align: "center",
        type: "text",
        canSearch: true,
        width: 100,
        fixed: "right",
      },
    ];

    let columns = [...columns_first, ...columns_date, ...columns_last];
    // console.log(columns);

    return columns;
  };

  const fetchData = (params = {}) => {
    setLoading(true);
    const lsDateInMonth = params.lsDate.filter(
      (item) => moment(currentSelectedDate).month() == moment(item).month()
    );
    GetDataOvertimeApi({
      listIdTeam: JSON.stringify(params.idTeam),
      tuNgay: moment(new Date(lsDateInMonth[0])).format("YYYYMMDD"),
      denNgay: moment(new Date(lsDateInMonth[lsDateInMonth.length - 1])).format(
        "YYYYMMDD"
      ),
    })
      .then((res) => {
        const newData = mapDataLichOT(res.data);
        const newColumns = mapColumnLichOT(res.data);
        setStatusAll(
          Math.min.apply(
            Math,
            res.data
              .filter((item) => item.statusId !== 0)
              .map(function (o) {
                return o.statusId;
              })
          )
        );
        setData([]);
        setData(newData[0]);
        setColumns(newColumns);
        setLsMemberId(newData[1]);
        setIsCreate(newData[0].length === 0);
        setLoading(false);
      })
      .catch((err) => {
        errorHandle(err);
        setLoading(false);
      });
  };

  const fetchListTeam = () => {
    ListBoPhanApi().then((res) => {
      const arrTeam = userInfo.team_permissions
        .filter((item) => item.phanquyen__ten_pq === "overtime_view")
        .map((item, index) => {
          const idBoPhanForTeam = res.data.filter((itemBP) =>
            itemBP.team.some((itemT) => itemT.id == item.team)
          );
          if (idBoPhanForTeam.length != 0) {
            return {
              idTeam: item.team,
              team: item.team__tenTeam,
              idBoPhan: idBoPhanForTeam[0].id,
            };
          }
          return false;
        })
        .filter((item) => item != false);
      const uniqueArrTeam = [
        ...new Map(arrTeam.map((item) => [item["idTeam"], item])).values(),
      ];
      if (uniqueArrTeam.length === 0) {
        openNotificationWithIcon("error", "Bạn chưa có quyền cho team.");
      }

      const arrIdTeam = uniqueArrTeam.map((item) => item.idTeam);
      const arrBoPhan = res.data.filter(({ team }) =>
        team.some((item) => arrIdTeam.includes(item.id))
      );
      if (arrBoPhan.length > 0) {
        setCurrentBoPhan([arrBoPhan[0].id]);
      }
      setLsBoPhan(arrBoPhan);

      setLsAllTeam(uniqueArrTeam);
      if (currentTeam.length === 0) {
        setCurrentTeam([
          arrIdTeam.filter((x) =>
            arrBoPhan[0].team.map((item) => item.id).includes(x)
          )[0],
        ]); // 200423 lấy element đầu tiên đặt trong list
      }
      setLsTeam(
        uniqueArrTeam.filter((x) =>
          arrBoPhan[0].team.map((item) => item.id).includes(x.idTeam)
        )
      );
    });
  };

  const fetchListDuAn = () => {
    GetDataDuAnApi().then((res) => {
      setLsDuAn(res.data);
    });
  };

  const submitApproval = (type, requirePerm, action) => {
    let lsTeamNotValid = [];
    const arrTeam = lsTeam.filter((item) => currentTeam.includes(item.idTeam));
    if (requirePerm.length === 1) {
      for (const iTeam of arrTeam) {
        let isValidPerm = [];
        isValidPerm = userInfo.team_permissions.filter(
          (item) =>
            item.phanquyen__ten_pq === requirePerm[0] &&
            iTeam.idTeam === item.team
        );
        if (isValidPerm.length === 0) {
          lsTeamNotValid.push(iTeam.team);
        }
      }
      if (lsTeamNotValid.length > 0) {
        openNotificationWithIcon(
          "error",
          "Lỗi",
          "Bạn không có quyền " +
            action +
            " với" +
            (lsTeamNotValid.length > 1 ? " các" : "") +
            " team " +
            lsTeamNotValid.join(", ")
        );
        return;
      }
    } else {
      for (const iTeam of arrTeam) {
        let arrPerm1 = 0;
        let arrPerm2 = 0;
        arrPerm1 = userInfo.team_permissions.filter(
          (item) =>
            item.phanquyen__ten_pq === requirePerm[0] &&
            iTeam.idTeam === item.team
        ).length;
        arrPerm2 = userInfo.team_permissions.filter(
          (item) =>
            item.phanquyen__ten_pq === requirePerm[1] &&
            iTeam.idTeam === item.team
        ).length;
        if (arrPerm1 === 0 || arrPerm2 === 0) {
          lsTeamNotValid.push(iTeam.team);
        }
      }
      if (lsTeamNotValid.length > 0) {
        openNotificationWithIcon(
          "error",
          "Lỗi",
          "Bạn không có quyền " +
            "Xem xét" +
            " với" +
            (lsTeamNotValid.length > 1 ? " các" : "") +
            " team " +
            lsTeamNotValid.join(", ")
        );
        return;
      }
    }
    if (!isValid) {
      openNotificationWithIcon(
        "error",
        "Lỗi",
        "Có dữ liệu không hợp lệ, vui lòng kiểm tra lại"
      );
      return;
    }
    setLoading(true);
    changeStatusOTApi({
      type: type,
      listIdOT: JSON.stringify(lsIdOT),
    })
      .then((res) => {
        updateData();
        setLoading(false);
        openNotificationWithIcon("success", "Thành công", "");
      })
      .catch((err) => {
        errorHandle(err);
        setLoading(false);
      });
  };

  useEffect(() => {
    if (
      userInfo &&
      userInfo.team_permissions &&
      userInfo.team_permissions.length > 0
    ) {
        fetchListTeam();

        // 231024 Dành cho TH User được phân quyền Tạo cho các team (DS team tạo có thể khác với DS team phần view team)
        // Nếu comment phần này, mở bên modal add thì phần set team cho quyền Quản lý - Tăng ca - Tạo sẽ không có tác dụng
        var lsTeamNew = [];
        const arrTeam = userInfo.team_permissions
            .filter((item) => item.phanquyen__ten_pq === "overtime_create")
            .map((item, index) => {
            return { idTeam: item.team, team: item.team__tenTeam };
            });
        lsTeamNew = [...new Set(arrTeam)];
        setLsTeamRoleCreateOT(lsTeamNew)
    }
    fetchListDuAn();
  }, [userInfo]);

  useEffect(() => {
    if (lsDate.length > 0 && currentTeam.length > 0) {
      fetchData({ idTeam: currentTeam, lsDate: lsDate });
    }
    if (currentTeam.length === 0) {
      setData([]);
    }
  }, [lsDate, currentTeam]);

  useEffect(() => {
    systemInfoApi().then((res) => {
      // console.log(res)
    });
  }, []);

  const updateData = () => {
    fetchData({ idTeam: currentTeam, lsDate: lsDate });
    fetchListDuAn();
  };

  const handleChange = (pagination) => {
    const currentPager = { ...pager };
    // @ts-ignore
    currentPager.current = pagination.current;
    currentPager.pageSize = pagination.pageSize;
    setPager({ ...currentPager });
    fetchData({
      // @ts-ignore
      status: currentPager.status,
      page_size: pagination.pageSize,
      page: pagination.current,
      search,
    });
  };

  const onChangeDate = (date) => {
    setIsCreate(false);
    setCurrentSelectedDate(date);
    const lsDateTemp = getDateRange(date);
    setLsDate(lsDateTemp);
  };

  const onChangeBoPhan = (value) => {
    if (value.length > 0) {
      setCurrentBoPhan(value);
      const lsTeamWith_BP = lsAllTeam.filter((x) => value.includes(x.idBoPhan));
      setLsTeam(lsTeamWith_BP);
      setCurrentTeam([lsTeamWith_BP.map((item) => item.idTeam)[0]]); // 200423
    } else {
      setLsTeam([]);
      setCurrentBoPhan([]);
      setCurrentTeam([]);
    }
  };

  const tPropsConfig_BoPhan = {
    treeData: [
      {
        title:
          currentBoPhan.length > 0 ? (
            <span
              onClick={() => {
                if (!loading) {
                  onChangeBoPhan([]);
                }
              }}
              className="style_SelectTeam"
            >
              Bỏ chọn tất cả
            </span>
          ) : (
            <span
              onClick={() => {
                if (!loading) {
                  onChangeBoPhan(lsBoPhan.map((item) => item.id));
                }
              }}
              className="style_SelectTeam"
            >
              Chọn tất cả
            </span>
          ),
        value: "xxx",
        disableCheckbox: true,
        disabled: true,
        className: "style_treeTeam",
      },
      ...treeDataBoPhan,
    ],
    value: treeDataBoPhan.length > 0 ? currentBoPhan : undefined,
    onChange: onChangeBoPhan,
    treeCheckable: true,
    // showCheckedStrategy: SHOW_PARENT,
    maxTagCount: 2,
    placeholder: "Chọn bộ phận",
    style: { width: "fit-content", minWidth: 200 },
    disabled: loading,
  };

  useEffect(() => {
    const treeDataBoPhan = lsBoPhan.map((item) => {
      return { title: item.tenBophan, value: item.id, key: item.id };
    });
    setTreeDataBoPhan(treeDataBoPhan);
    if (currentBoPhan.length === 0) {
      setCurrentBoPhan(lsBoPhan.map((item) => item.id));
    }
  }, [lsBoPhan]);

  useEffect(() => {
    const arrDay = generateArrWeekAndDays(
      currentSelectedDate.year(),
      currentSelectedDate.month() + 1
    );
    setLsAllWeek(arrDay);
    setCurrentWeek(
      arrDay.filter((item) =>
        item.days.some((date) => date.isSame(currentSelectedDate, "date"))
      )[0].name
    );
  }, [currentSelectedDate]);

  const onQuickChangeWeek = (type) => {
    if (loading) {
      return;
    }
    const arrDay = generateArrWeekAndDays(
      currentSelectedDate.year(),
      currentSelectedDate.month() + 1
    );
    let lenWeek = 7;
    if (type === "previous") {
      arrDay.forEach(function (iWeek, index) {
        if (
          iWeek.days.some((date) => date.isSame(currentSelectedDate, "date"))
        ) {
          if (index == 0) {
            arrDay[index].days.length == 7 ? (lenWeek = -7) : (lenWeek = 0);
          } else {
            lenWeek = -arrDay[index - 1].days.length;
          }
        }
      });
    } else {
      arrDay.forEach(function (iWeek, index) {
        if (
          iWeek.days.some((date) => date.isSame(currentSelectedDate, "date"))
        ) {
          index == arrDay.length - 1
            ? (lenWeek = arrDay[arrDay.length - 1].days.length)
            : (lenWeek = 7);
        }
      });
    }
    const numberDay = lenWeek;
    // const numberDay = type === 'previous' ? -7 : 7
    const newFirstDate = new Date(
      new Date(lsDate[0]).getTime() + numberDay * 24 * 60 * 60 * 1000
    );
    const lsDateTemp = getDateRange(moment(newFirstDate));
    setCurrentSelectedDate(moment(newFirstDate));
    setLsDate(lsDateTemp);

    const arrDayNew = generateArrWeekAndDays(
      moment(newFirstDate).year(),
      moment(newFirstDate).month() + 1
    );
    setLsAllWeek(arrDayNew);
    setCurrentWeek(
      arrDayNew.filter((item) =>
        item.days.some((date) => date.isSame(moment(newFirstDate), "date"))
      )[0].name
    );
  };

  const onChangeSelectWeek = (value) => {
    setCurrentWeek(value);
    const lsAllWeekChange = lsAllWeek.filter((item) => item.name == value);
    setCurrentSelectedDate(lsAllWeekChange[0].days[0]);
    setLsDate(lsAllWeekChange[0].days);
  };

  const onChangeTeam = (value) => {
    if (value.length > 0) {
      setCurrentTeam(value);
    } else {
      setCurrentTeam([]);
    }
  };

  const tPropsConfig = {
    treeData: [
      {
        title:
          currentTeam.length > 0 ? (
            <span
              onClick={() => setCurrentTeam([])}
              className="style_SelectTeam"
              // style={{
              //   display: "inline-block",
              //   color: "#286FBE",
              //   cursor: "pointer",
              // }}
            >
              Bỏ chọn tất cả
            </span>
          ) : (
            <span
              onClick={() => setCurrentTeam(lsTeam.map((item) => item.idTeam))}
              className="style_SelectTeam"
              // style={{
              //   display: "inline-block",
              //   color: "#286FBE",
              //   cursor: "pointer",
              // }}
            >
              Chọn tất cả
            </span>
          ),
        value: "xxx",
        disableCheckbox: true,
        disabled: true,
        className: "style_treeTeam",
      },
      ...treeData,
    ],
    value: treeData.length > 0 ? currentTeam : undefined,
    onChange: onChangeTeam,
    treeCheckable: true,
    // showCheckedStrategy: SHOW_PARENT,
    maxTagCount: 2,
    placeholder: "Chọn team",
    style: { width: "fit-content", minWidth: 200 },
    disabled: loading,
  };

  useEffect(() => {
    const treeDataTemp = lsTeam.map((item) => {
      return { title: item.team, value: item.idTeam, key: item.idTeam };
    });
    setTreeData(treeDataTemp);
    // setCurrentTeam(lsTeam.map(item=>item.idTeam));
  }, [lsTeam]);

  return (
    <>
      <div className="row">
        <div className="col-12">
          <div className="page-title-box d-sm-flex align-items-center justify-content-between">
            <h4 className="mb-sm-0 font-size-18">
              Lịch tăng ca (
              {moment(
                lsDate.filter(
                  (item) =>
                    moment(currentSelectedDate).month() == moment(item).month()
                )[0]
              ).format("DD/MM/YYYY") +
                "-" +
                moment(
                  lsDate
                    .filter(
                      (item) =>
                        moment(currentSelectedDate).month() ==
                        moment(item).month()
                    )
                    .at(-1)
                ).format("DD/MM/YYYY")}
              )
            </h4>
            <div className="page-title-right">
              <ol className="breadcrumb m-0">
                <li className="breadcrumb-item">
                  <Link href="#">Quản lý</Link>
                </li>
                <li className="breadcrumb-item">Lịch làm việc</li>
                <li className="breadcrumb-item active">Tăng ca</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className={"col-12 mb-2 d-sm-flex align-items-center"}>
          <div className={"col"}>
            <Space align="center" className="space-align-block styleNtn_1">
              <Button
                type="primary"
                className={"styleNtn_1 addBtnWeek"}
                onClick={() => onQuickChangeWeek("previous")}
                title="Tuần trước"
              >
                <i className={"fa fa-arrow-left"}></i>
              </Button>
              <Select onChange={onChangeSelectWeek} value={currentWeek}>
                {lsAllWeek.map((item, key) => (
                  <Select.Option key={item.name} value={item.name}>
                    {item.name}
                  </Select.Option>
                ))}
              </Select>

              <Button
                type="primary"
                className={"styleNtn_1 addBtnWeek"}
                onClick={() => onQuickChangeWeek("next")}
                title="Tuần sau"
              >
                <i className={"fa fa-arrow-right"}></i>
              </Button>
            </Space>

            <DatePicker
              style={{ borderRadius: 10 }}
              className={"m-2"}
              onChange={onChangeDate}
              value={currentSelectedDate}
              format={"DD/MM/YYYY"}
              allowClear={false}
            />

            <div className="styleBadge">
              <Badge.Ribbon
                text="Bộ phận"
                color="gray"
                style={{ color: "red" }}
              >
                <TreeSelect {...tPropsConfig_BoPhan} />
              </Badge.Ribbon>
            </div>
            <div className="styleBadge">
              <Badge.Ribbon text="Team" color="gray" style={{ color: "red" }}>
                <TreeSelect {...tPropsConfig} />
              </Badge.Ribbon>
            </div>
            {statusAll &&
              userInfo &&
              userInfo.team_permissions &&
              systemGroup &&
              systemGroup.length > 0 &&
              currentTeam.length > 0 &&
              !loading && (
                <GetLsButton
                  permissions={userInfo.user_permissions}
                  systemGroup={systemGroup}
                  status={statusAll}
                  lsDate={lsDate}
                  teamPermissions={userInfo.team_permissions}
                />
              )}
          </div>
        </div>
      </div>
      <div className="row">
        <Table
          dataSource={data}
          columns={columns}
          loading={loading}
          bordered={true}
          scroll={data.length > 0 && { x: 1200, y: 600 }}
          // scroll={{x:1920}}
          className={"custom-table-hover style-6"}
          sticky={true}
          size={"small"}
          rowKey="id"
          onChange={handleChange}
          pagination={false}
        />
      </div>
      <ModalAddOvertime
        visible={isShowAdd}
        onCancel={() => setIsShowAdd(false)}
        lsDate={lsDate}
        data={data}
        lsMemberId={lsMemberId}
        currentTeam={currentTeam}
        lsTeamRoleCreateOT={lsTeamRoleCreateOT}
        lsDuAn={lsDuAn}
        updateData={updateData}
        fetchListDuAn={fetchListDuAn}
        userInfo={userInfo}
      />
      <ModalDetailItem
        visible={isShowDetailItem}
        onCancel={() => setIsShowDetailItem(false)}
        itemDetail={currentItem}
        currentDate={currentDateSelected}
        updateData={updateData}
      />
      <ModalDeleteItem
        visible={isShowDelete}
        onCancel={() => setIsShowDelete(false)}
        lsMemberId={lsMemberId}
        lsTeam={lsTeam}
        updateData={updateData}
      />
    </>
  );
};
